import React from 'react'
import PropTypes from 'prop-types'
import { Heading, Level, Text, Price, Box } from '@deseretbook/react-ui'


/**
 * Displays a price estimate breakdown for the specified subscription plan.
 *
 * @returns {function} Component
 */
const SubscriptionPriceSummary = ({ subscription }) => {
  const billingPeriodText = subscription.subscriptionPlan && subscription.subscriptionPlan.yearly
    ? 'year'
    : 'month'
  const billingDateText = (
    !subscription.firstBillingDate
    || new Date(`${subscription.firstBillingDate} 00:00:00`).toDateString() === new Date().toDateString()
    || !subscription.trialPeriod
  )
    ? 'You will be billed immediately.'
    : `You will be billed on ${new Date(`${subscription.firstBillingDate} 00:00:00`).toLocaleDateString(undefined, { day: 'numeric', month: 'long', year: 'numeric' })} after your ${subscription.trialDuration}-${subscription.trialDurationUnit} trial has expired.`
  const billingFrequencyText = `You will automatically be charged every ${billingPeriodText} after your first billing date or until you cancel your subscription.`
  const priceChangeText = 'This price is an estimate and is subject to change.'

  return (
    <React.Fragment>
      <Heading>{subscription.subscriptionPlan.name}</Heading>
      <Level>
        <Level.Left>
          <Level.Item>
            <Text>Subtotal</Text>
          </Level.Item>
        </Level.Left>
        <Level.Right>
          <Level.Item>
            <Text>
              <Price value={subscription.subscriptionPlan.price} />
            </Text>
          </Level.Item>
        </Level.Right>
      </Level>

      {/* Display Discounts */}
      {subscription.discounts
        .map(({
          name,
          code,
          amount,
          id,
        }) => (
          <Level key={id}>
            <Level.Left>
              <Level.Item>
                <Text hasEllipsis>{name || code}</Text>
              </Level.Item>
            </Level.Left>
            <Level.Right>
              <Level.Item>
                <Text hasEllipsis>
                  <Price value={-1 * amount} />
                </Text>
              </Level.Item>
            </Level.Right>
          </Level>
        ))}

      {/* Display Addons */}
      {subscription.addOns
        .map(({
          amount,
          code,
          name,
          id,
        }) => (
          <Level key={id}>
            <Level.Left>
              <Level.Item>
                <Text>{name || code}</Text>
              </Level.Item>
            </Level.Left>
            <Level.Right>
              <Level.Item>
                <Text>
                  <Price value={amount} />
                </Text>
              </Level.Item>
            </Level.Right>
          </Level>
        ))}

      <Level>
        <Level.Left>
          <Level.Item>
            <Text>Estimated Total</Text>
          </Level.Item>
        </Level.Left>
        <Level.Right>
          <Level.Item>
            <Text isBold>
              <Price value={subscription.nextBillingPeriodAmount} />
            </Text>
          </Level.Item>
        </Level.Right>
      </Level>

      <Box paddingTop={1}>
        <Text size="tiny">
          {billingDateText} {billingFrequencyText} {priceChangeText}
        </Text>
      </Box>
    </React.Fragment>
  )
}

SubscriptionPriceSummary.propTypes = {
  subscription: PropTypes.shape({}),
}

SubscriptionPriceSummary.defaultProps = {
  subscription: {
    subscriptionPlan: {},
  },
}

export default SubscriptionPriceSummary
